import { combineReducers } from 'redux';

import mealAddons, * as fromMealAddons from './mealAddons';
import offerRewards, * as fromOfferRewards from './offerRewards';
import optIns, * as fromOptIns from './optIns';
import orderHistory, * as fromOrderHistory from './orderHistory';
import partnerDeals from './partnerDeals';
import pastReceipts, * as fromPastReceipts from './pastReceipts';
import pauseDeflectorMeals, * as fromPauseDeflectorMeals from './pauseDeflectorMeals';
import pauseOfferRewards, * as fromPauseOfferRewards from './pauseOfferRewards';
import pauseReasons from './pauseReasons';
import streakOffers, * as fromStreakOffers from './streakOffers';
import tasteProfile, * as fromTasteProfile from './tasteProfile';

export default combineReducers({
  mealAddons,
  offerRewards,
  optIns,
  orderHistory,
  partnerDeals,
  pauseDeflectorMeals,
  pauseOfferRewards,
  pastReceipts,
  pauseReasons,
  streakOffers,
  tasteProfile,
});

const selectAccount = state => state.account;

const selectOrderHistory = state => selectAccount(state).orderHistory;
const selectMealAddons = state => selectAccount(state).mealAddons;
const selectOptIns = state => selectAccount(state).optIns;
const selectTasteProfile = state => selectAccount(state).tasteProfile;
const selectPauseDeflectorMeals = state => selectAccount(state).pauseDeflectorMeals;
export const selectPauseReasonsIsLoading = state => selectAccount(state).pauseReasons.isLoading;
export const selectPauseReasons = state => selectAccount(state).pauseReasons.pauseReasons;
export const selectStreakOffers = state => selectAccount(state).streakOffers;
export const selectPartnerDeals = state => selectAccount(state).partnerDeals;
export const selectPastReceipts = state => selectAccount(state).pastReceipts;
export const selectOfferRewards = state => selectAccount(state).offerRewards;

export const selectPauseDisqualifiableStreakOffers = state =>
  fromStreakOffers.selectPauseDisqualifiableStreakOffers(selectStreakOffers(state));

export const selectPastReceipt = (state, menuSlug) =>
  fromPastReceipts.selectReceipt(selectPastReceipts(state), menuSlug);
export const selectPastReceiptLoading = state =>
  fromPastReceipts.selectReceiptLoading(selectPastReceipts(state));

export const selectOrderHistoryPastOrders = (state, page) =>
  fromOrderHistory.selectOrderHistoryPastOrders(selectOrderHistory(state), page);
export const selectOrderHistoryLoading = state =>
  fromOrderHistory.selectOrderHistoryLoading(selectOrderHistory(state));
export const selectOrderHistoryNumberOfPages = state =>
  fromOrderHistory.selectOrderHistoryNumberOfPages(selectOrderHistory(state));
export const selectOrderHistoryFailed = state =>
  fromOrderHistory.selectOrderHistoryFailed(selectOrderHistory(state));

export const selectMealAddonsResults = state =>
  fromMealAddons.selectMealAddonsResults(selectMealAddons(state));
export const selectMealAddonsLoading = state =>
  fromMealAddons.selectMealAddonsLoading(selectMealAddons(state));
export const selectMealAddonsFailed = state =>
  fromMealAddons.selectMealAddonsFailed(selectMealAddons(state));
export const selectMealAddonsUpdating = state =>
  fromMealAddons.selectMealAddonsUpdating(selectMealAddons(state));

export const selectOptInsResults = state => fromOptIns.selectOptInsResults(selectOptIns(state));
export const selectOptInsLoading = state => fromOptIns.selectOptInsLoading(selectOptIns(state));
export const selectOptInsFailed = state => fromOptIns.selectOptInsFailed(selectOptIns(state));
export const selectOptInsUpdating = state => fromOptIns.selectOptInsUpdating(selectOptIns(state));

export const selectPauseDeflectorMealsResults = state =>
  fromPauseDeflectorMeals.selectPauseDeflectorMealsResults(selectPauseDeflectorMeals(state));
export const selectPauseDeflectorMealsFetching = state =>
  fromPauseDeflectorMeals.selectPauseDeflectorMealsFetching(selectPauseDeflectorMeals(state));
export const selectPauseDeflectorMealsFailed = state =>
  fromPauseDeflectorMeals.selectPauseDeflectorMealsFailed(selectPauseDeflectorMeals(state));

export const selectPauseOfferRewardsDisqualifiableBehavioralDiscounts = state =>
  fromPauseOfferRewards.selectPauseOfferRewardsDisqualifiableBehavioralDiscounts(state);

export const selectTasteProfilePreferences = state =>
  fromTasteProfile.selectTasteProfilePreferences(selectTasteProfile(state));
export const selectTasteProfileAllergies = state =>
  fromTasteProfile.selectTasteProfileAllergies(selectTasteProfile(state));
export const selectTasteProfileSpicePreferences = state =>
  fromTasteProfile.selectTasteProfileSpicePreferences(selectTasteProfile(state));
export const selectTasteProfileLoading = state =>
  fromTasteProfile.selectTasteProfileLoading(selectTasteProfile(state));
export const selectTasteProfileError = state =>
  fromTasteProfile.selectTasteProfileError(selectTasteProfile(state));
export const selectTasteProfileUpdating = state =>
  fromTasteProfile.selectTasteProfileUpdating(selectTasteProfile(state));

export const selectWeeklyBasket = state =>
  fromOfferRewards.selectWeeklyBasket(selectOfferRewards(state));
export const selectCurrentMenuSlug = state =>
  fromOfferRewards.selectCurrentMenuSlug(selectOfferRewards(state));
export const selectBasketDiscount = state =>
  fromOfferRewards.selectBasketDiscount(selectOfferRewards(state));
export const selectBasketVoucherDetails = state =>
  fromOfferRewards.selectBasketVoucherDetails(selectOfferRewards(state));
export const selectCredit = state => fromOfferRewards.selectCredit(selectOfferRewards(state));
export const selectCreditDetails = state =>
  fromOfferRewards.selectCreditDetails(selectOfferRewards(state));
const selectOrderDiscountDetails = state =>
  fromOfferRewards.selectOrderDiscountDetails(selectOfferRewards(state)) || [];
export const selectCurrentOrderDiscount = state => {
  return selectOrderDiscountDetails(state).find(discount => discount.isCurrentDiscount);
};
